import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Box,
    Typography,
    IconButton,
    Stack,
    Divider,
    Skeleton,
    AppBar,
    Grid2,
    InputAdornment,
    CircularProgress,
    Tooltip,
} from '@mui/material';

import PrimaryHeading from '../commonPrimaryHeading';
import SecondaryHeading from '../commonSecondaryHeading';
import PencnlIconImg from '../../../assets/edit-2.png';
import DeleteIconImg from '../../../assets/DeleteIcon.png';

import apiFetcher from '../../../utils/interCeptor';
import { useFormik } from 'formik';
import CustomDeleteModal from '../../deleteAlertModal';
import { toast } from 'react-toastify';
import _ from 'lodash';

import EmployeeModel from './EmployeeModel';
import FSwitch from '../../commonComponents/f-switch';
import { useSelector, useDispatch } from 'react-redux';
import { settings as settingsSlice } from '../../../context/settingsSlice';
import Notauthorized from '../../commonComponents/F_Notauthorized';

import { t } from 'i18next';
import FSelect from '../../commonComponents/F_Select';
import { DeleteEmployeeApi } from '../../../utils/Api/Employee';
import { dividerSx } from '../../../scenes/Settings/settigs.layout';
import FPrimaryHeading from '../../commonComponents/F_PrimaryHeading';
import { GetServiceGroup } from '../../../utils/Api/Service';
import FTextInput from '../../commonComponents/F_TextInput';
import { formatCurrency } from '../../../scenes/POS/Core/pos.utils';
import { useFieldArray, useForm } from 'react-hook-form';
import { api } from '../../../utils/Api/POS';
import FButton from '../../commonComponents/F_Button';
import {
    getEmployeePermissionMapper,
    getEmployeePermissionsDefault,
    permissionTemplateMap,
    normalizePermissionTemplate,
    areAllEmployeePermissionsEnabled,
    BLUR_PRICE_PERMISSION_ID,
} from './employee-permission-mapper';
import { mapStoreInvitedEmployeeRow } from './inviteEmployeeApiShape';
import { resendStoreEmployeeInviteV3Api } from '@/utils/Api/AuthV3';
import { Masonry } from '@mui/lab';
import { Link } from 'react-router-dom';
import { InfoOutlined, MailOutline } from '@mui/icons-material';

function employeeListAvatarSrc(image) {
    if (typeof image !== 'string') return undefined;
    const trimmed = image.trim();
    if (!trimmed) return undefined;
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
    return `${process.env.REACT_APP_IMG_URL}${trimmed}`;
}

const EmployeeSettingsOption = () => {
    const user = useSelector((state) => state.user.data);
    const settingsSelector = useSelector((state) => state.settings.data);
    const dispatch = useDispatch();
    const isInspectionEnabled = settingsSelector?.profile?.inspection_module;
    const isFromDashboard = settingsSelector?.from_dashboard === true;
    const empOptions = settingsSelector?.employees?.map((emp) => {
        return { value: emp?.id, label: `${emp?.name} ${emp?.role === 'DOCTOR' ? `(${emp?.role})` : ''}` };
    });

    const employeePermissionMapper = getEmployeePermissionMapper({ t });
    const defaultPermissions = getEmployeePermissionsDefault({ t, value: false });
    const permissionTemplateOptions = [
        { value: 'CUSTOM', label: t('Setting.RolePresetCustom') },
        { value: 'EMPLOYEE', label: t('Setting.PresetEmployee') },
        { value: 'MARKETING', label: t('Setting.PresetMarketing') },
        { value: 'DOCTOR', label: t('Setting.PresetDoctor') },
        { value: 'MANAGER', label: t('Setting.PresetManager') },
        { value: 'OWNER', label: t('Setting.PresetOwner') },
    ];

    const [showModal, setShowModal] = useState(false);
    const [editEmployee, setEditEmployee] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [enableSave, setEnableSave] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resendingInviteId, setResendingInviteId] = useState(null);
    const [selectedPermissionTemplate, setSelectedPermissionTemplate] = useState('CUSTOM');
    const [serviceGroups, setServiceGroups] = useState([]);
    const [assignSelectedEmployee, setAssignSelectedEmployee] = useState(empOptions[0]?.value);
    const [initialValues, setInitialValues] = useState({
        id: null,
        name: '',
        phone: '',
        accessCode: '',
        journalAccess: false,
        image: '',
        role: '',
        employeeId: null,
        allPermission: false,
        permission: defaultPermissions || {},
        selectedEmployee: {
            id: null,
            name: 'test',
            phone: '123123',
            accessCode: '23432',
            journalAccess: false,
            image: '',
            role: '',
        },
        // inspection_module Settings For Employee
        auto_sms_employee_before_hours:
            settingsSelector?.OnlineBooking?.inspection_module?.auto_sms_employee_before_hours || 'NO_SMS',
    });

    const { control, watch, setValue } = useForm({
        defaultValues: {
            services: [],
        },
    });

    const { append, remove, update } = useFieldArray({
        control,
        name: 'services',
    });
    const [initialServices, setInitialServices] = useState([]);
    const servicesSelected = watch('services');
    const normalize = (arr = []) =>
        arr
            .map((service) => ({
                serviceId: service?.serviceId,
                employeePrice: Number(service?.employeePrice),
            }))
            .sort((a, b) => a.serviceId - b.serviceId);
    const serviceDirty = !_.isEqual(normalize(initialServices), normalize(servicesSelected));

    const getEmployees = async () => {
        try {
            const response = await apiFetcher.get('/api/v1/store/employee/get?include_invited=true');

            const { success, data, invited } = response.data;
            const activeRaw = Array.isArray(data) ? data : [];
            const invitedRaw = Array.isArray(invited) ? invited : [];

            if (success && (activeRaw.length > 0 || invitedRaw.length > 0)) {
                let dataValue = activeRaw.map((dataObj) => {
                    let newData = JSON.stringify(dataObj);
                    let newObj = { ...JSON.parse(newData) };
                    const permission = { ...newObj.settings };
                    delete newObj.settings;

                    return {
                        ...newObj,
                        label: `${newObj?.name} ${newObj?.role === 'DOCTOR' ? `(${newObj?.role})` : ''}`,
                        value: newObj?.id,
                        permission,
                        selectedEmployee: false,
                    };
                });

                dataValue = dataValue.filter((dataObj) => dataObj?.id !== user?.id);

                const invitedMapped = invitedRaw.map((inv) => mapStoreInvitedEmployeeRow(inv, t));

                const invitedFiltered = invitedMapped.filter((row) => row?.id !== user?.id);
                setEmployees([...dataValue, ...invitedFiltered]);

                if (activeRaw.length > 0) {
                    let foundEmployee = dataValue[0];
                    if (formik.values?.id) {
                        foundEmployee = dataValue.find((e) => e.id == formik.values.id) || dataValue[0];
                    }

                    setSelectedPermissionTemplate(normalizePermissionTemplate(foundEmployee?.permission_template));

                    const allPermission =
                        Object.keys(foundEmployee?.permission).length > 0 &&
                        Object.values(foundEmployee?.permission).every(Boolean);

                    // Root cause fix:
                    // The API may return a *partial* `settings` object (missing keys).
                    // If we keep permissions partial, toggling/saving one "view_*" key can
                    // make sibling keys appear/reset to false because they become `undefined`.
                    // Always hydrate to the full known permission shape.
                    const permission = { ...defaultPermissions, ...(foundEmployee?.permission || {}) };
                    // delete foundEmployee.settings;

                    const empData = {
                        ...foundEmployee,
                        permission,
                        selectedEmployee: {
                            id: null,
                            name: '',
                            phone: '',
                            accessCode: '',
                            journalAccess: false,
                            image: '',
                            role: '',
                        },
                        allPermission,
                        auto_sms_employee_before_hours:
                            settingsSelector?.OnlineBooking?.inspection_module?.auto_sms_employee_before_hours ||
                            'NO_SMS',
                    };
                    // `enableReinitialize`: only update `initialValues` so Formik `values` stay in sync in one
                    // update (avoid one-frame mismatch vs `setValues` + `setInitialValues` flashing the save bar).
                    setInitialValues(empData);
                }
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);

            console.error('err', err);
        }
    };

    const updatePermissionAPI = async (value) => {
        try {
            const { id, permission } = value;
            // Always send the full known permission set (avoid wiping missing keys server-side).
            const payload = { ...defaultPermissions, ...(permission || {}) };
            const response = await apiFetcher.patch(`/api/v1/store/employee/setting/${id}`, payload, {
                params: { permission_template: selectedPermissionTemplate },
            });
            const { success } = response.data;
            if (success) {
                toast.success(t('Setting.PermissionsUpdated'));

                setInitialValues(formik.values);
                getEmployees();
            }

            setEnableSave(false);

            formik.setSubmitting(false);
        } catch (err) {
            toast.error(t('Setting.FailedToUpdatePermission'));
            console.error('err', err);
            formik.setSubmitting(false);
        }
    };

    const updateInspectionModuleAPI = async (values) => {
        try {
            const settingsPayload = {
                ...settingsSelector?.OnlineBooking,
                inspection_module: {
                    ...settingsSelector?.OnlineBooking?.inspection_module,
                    auto_sms_employee_before_hours:
                        values?.auto_sms_employee_before_hours === 'NO_SMS'
                            ? 0
                            : values?.auto_sms_employee_before_hours,
                },
            };

            const stringifiedSettingsPayload = JSON.stringify(settingsPayload);

            await apiFetcher.patch('/api/v1/store/outlet/setting', {
                settings: [
                    {
                        settingCategory: 'outlet',
                        settingName: 'OnlineBooking',
                        value: stringifiedSettingsPayload,
                        type: 'JSON',
                    },
                ],
            });
            setEnableSave(false);
            dispatch(settingsSlice({ ...settingsSelector, OnlineBooking: settingsPayload }));
        } catch (err) {
            toast.error(t('Setting.FailedToUpdatePermission'));
            console.error('err', err);
        } finally {
            formik.setSubmitting(false);
        }
    };

    const deleteEmployee = async (values) => {
        setShowDeleteModal(false);
        try {
            // let url = `/api/v1/store/employee/${values?.id}`;
            await DeleteEmployeeApi({ id: values?.id });
            getEmployees();
            toast.success(t('Setting.EmployeeDeleted'));
            setEditEmployee(null);
        } catch (err) {
            toast.error(t('Setting.FailedToDeleteEmployee'));
            setEditEmployee(null);
        }
    };

    const getEmployeeInvitationId = (employee) => {
        const id = employee?.invitation_id ?? employee?.value ?? employee?.id;
        return id != null && id !== '' ? String(id) : '';
    };

    const handleResendInvite = async (employee) => {
        const invitationId = getEmployeeInvitationId(employee);
        if (!invitationId) {
            toast.error(t('Setting.EmployeeInviteResendFailed'));
            return;
        }
        setResendingInviteId(invitationId);
        try {
            await resendStoreEmployeeInviteV3Api(invitationId);
            toast.success(t('Setting.EmployeeInviteResent'));
        } catch (err) {
            const apiMsg = err?.response?.data?.detail ?? err?.response?.data?.msg ?? err?.response?.data?.message;
            toast.error(apiMsg || t('Setting.EmployeeInviteResendFailed'));
        } finally {
            setResendingInviteId(null);
        }
    };

    const handleChangeSelectedEmployee = (event) => {
        const foundEmployee = employees.find((empObj) => empObj.id == event.target.value && !empObj.invite_pending);

        if (foundEmployee) {
            setSelectedPermissionTemplate(normalizePermissionTemplate(foundEmployee.permission_template));
            const hydratedPermission = { ...defaultPermissions, ...(foundEmployee?.permission || {}) };
            const allPermission = areAllEmployeePermissionsEnabled(hydratedPermission);

            formik.setValues({
                ...foundEmployee,
                permission: hydratedPermission,
                selectedEmployee: {
                    id: null,
                    name: '',
                    phone: '',
                    accessCode: '',
                    journalAccess: false,
                    image: '',
                    role: '',
                },
                allPermission,
                auto_sms_employee_before_hours:
                    settingsSelector?.OnlineBooking?.inspection_module?.auto_sms_employee_before_hours || 'NO_SMS',
            });

            setInitialValues({
                ...foundEmployee,
                permission: hydratedPermission,
                auto_sms_employee_before_hours:
                    settingsSelector?.OnlineBooking?.inspection_module?.auto_sms_employee_before_hours || 'NO_SMS',
                selectedEmployee: {
                    id: null,
                    name: '',
                    phone: '',
                    accessCode: '',
                    journalAccess: false,
                    image: '',
                    role: '',
                },
                allPermission,
            });
        }
        // formik.setFieldValue()
        // setSelectedEmployee(event.target.value);
    };

    useEffect(() => {
        setLoading(true);
        getEmployees();
        fetchServices();
    }, []);

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues,

        onSubmit: async (values) => {
            //   alert(JSON.stringify(values, null, 2));
            if (enableSave) {
                await updatePermissionAPI(values);
                await updateInspectionModuleAPI(values);
            }
            if (serviceDirty) {
                await handleServiceAssign();
            }
        },
    });

    const setAllPermission = (value) => {
        setSelectedPermissionTemplate('CUSTOM');
        const preservedBlurPrice = formik.values.permission?.[BLUR_PRICE_PERMISSION_ID];
        formik.setFieldValue('allPermission', value);

        const newPermissions = getEmployeePermissionsDefault({ t, value });
        newPermissions[BLUR_PRICE_PERMISSION_ID] = preservedBlurPrice;
        formik.setFieldValue('permission', { ...newPermissions });
    };

    const applyPermissionTemplate = (template) => {
        setSelectedPermissionTemplate(template);
        if (template === 'CUSTOM') return;

        const selectedKeys =
            template === 'OWNER' ? Object.keys(defaultPermissions) : permissionTemplateMap[template] || [];
        const nextPermissions = getEmployeePermissionsDefault({ t, value: false });

        selectedKeys.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(nextPermissions, key)) {
                nextPermissions[key] = true;
            }
        });

        formik.setFieldValue('permission', nextPermissions);
        formik.setFieldValue('allPermission', Object.values(nextPermissions).every(Boolean));
    };

    const onChangeValue = (option, checked) => {
        setSelectedPermissionTemplate('CUSTOM');
        if (option.id === BLUR_PRICE_PERMISSION_ID && !isFromDashboard) {
            return;
        }
        // Domain rule: for Customers/Services/Special offers, "view_*" is the master permission.
        // If view is turned OFF, turn OFF all permissions in the same domain.
        const VIEW_DEPENDENCIES = {
            view_customers: ['create_customers', 'edit_customers', 'delete_customers'],
            view_service_list: ['crud_services'],
            view_special_offers: ['crud_special_offers'],
        };

        let newPermission = { ...formik.values.permission, [option.id]: checked };

        const dependents = VIEW_DEPENDENCIES[option.id];
        if (dependents && checked === false) {
            dependents.forEach((depKey) => {
                newPermission[depKey] = false;
            });
        }

        // If a dependent permission is turned ON, ensure its domain "view_*" is also ON.
        const DEPENDENT_TO_VIEW = Object.entries(VIEW_DEPENDENCIES).reduce((acc, [viewKey, deps]) => {
            deps.forEach((depKey) => {
                acc[depKey] = viewKey;
            });
            return acc;
        }, {});

        const requiredView = DEPENDENT_TO_VIEW[option.id];
        if (requiredView && checked === true) {
            newPermission[requiredView] = true;
        }

        formik.setFieldValue('permission', newPermission);
        // if (!checked) {
        //   formik.setFieldValue("allPermission", checked);
        // }else{

        formik.setFieldValue('allPermission', areAllEmployeePermissionsEnabled(newPermission));
        // }
    };

    useEffect(() => {
        const initialValuesData = {
            ...initialValues?.permission,
            auto_sms_employee_before_hours: initialValues?.auto_sms_employee_before_hours,
        };
        const formikValuesData = {
            ...formik.values?.permission,
            auto_sms_employee_before_hours: formik.values?.auto_sms_employee_before_hours,
        };
        setTimeout(() => {
            setEnableSave(!_.isEqual(initialValuesData, formikValuesData));
        }, 500);
    }, [formik.values, initialValues]);

    useEffect(() => {
        if (!assignSelectedEmployee || !serviceGroups?.length) return;

        const allServices = serviceGroups.flatMap((group) => group?.services || []);

        const preAssignedServices = allServices
            .filter((service) => service?.employees?.some((emp) => emp?.id === assignSelectedEmployee))
            .map((service) => {
                const emp = service?.employees.find((employee) => employee?.id === assignSelectedEmployee);

                return {
                    serviceId: service?.id,
                    employeePrice: Number(emp?.price ?? service?.price),
                };
            });

        setValue('services', preAssignedServices);

        setInitialServices(_.cloneDeep(preAssignedServices));
    }, [assignSelectedEmployee, serviceGroups]);

    const fetchServices = async () => {
        try {
            setLoading(true);
            const response = await GetServiceGroup();
            setServiceGroups(response?.data?.data || []);
        } catch (error) {
            console.error('Error : ', error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleService = (service, checked) => {
        const index = servicesSelected?.findIndex((ser) => ser?.serviceId === service?.id);

        if (checked) {
            const emp = service?.employees?.find((employee) => employee?.id === assignSelectedEmployee);

            append({
                serviceId: service?.id,
                employeePrice: Number(emp?.price ?? service.price),
            });
        }

        if (!checked) {
            remove(index);
        }
    };

    const handleServiceAssign = async () => {
        try {
            const response = await api.putApiServicesEmployeeAssignEmployeeId(assignSelectedEmployee, {
                services: servicesSelected,
            });
            if (response || response?.success === true) {
                setEnableSave(false);
                setInitialServices(_.cloneDeep(servicesSelected));
                toast.success(t('Setting.ServiceAssignSucc'));
                await fetchServices();
            }
        } catch (error) {
            console.error('Error : ', error);
            toast.error(t('Common.ToastWrong'));
        } finally {
            setLoading(false);
        }
    };

    if (!user?.settings.view_settings_employees && user.role !== 'ADMIN') {
        return <Notauthorized />;
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            {(enableSave || serviceDirty) && (
                <AppBar
                    sx={{
                        position: 'sticky',
                        zIndex: 20,
                        top: 45,
                        left: 0,
                        py: 1,
                        px: 4,
                        height: 50,
                        bgcolor: '#fff',
                        display: 'flex',
                        // justifyContent: "flex-end",
                        alignItems: 'flex-end',
                        width: '100%',
                    }}
                >
                    <FButton
                        onClick={formik.handleSubmit}
                        width="auto"
                        ml={'auto'}
                        height={40}
                        variant={'save'}
                        title={
                            formik.isSubmitting ? (
                                <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                    <CircularProgress size={20} color="inharit" />
                                    {t('POS.Processing')}
                                </Stack>
                            ) : (
                                t('Setting.SaveChanges')
                            )
                        }
                        disabled={formik.isSubmitting}
                        sx={{ bgcolor: formik.isSubmitting && '#d2d2d2' }}
                    />
                </AppBar>
            )}
            <Stack p={{ xs: 2, md: 2 }}>
                <Stack spacing={6} sx={{ bgcolor: '#fff', borderRadius: '25px', minHeight: '86vh' }}>
                    {/* Employees */}
                    <Grid2 container spacing={3} sx={{ p: { xs: 2, md: 5 } }}>
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <PrimaryHeading sx={{ textTransform: 'capitalize' }} text={t('Common.Employees')} />
                            <SecondaryHeading text={t('Setting.Description11')} />
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 8 }}>
                            {loading ? (
                                <Stack width="100%" spacing={1}>
                                    {[...Array(7)].map((_, index) => (
                                        <Grid2
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                gap: 4,
                                            }}
                                        >
                                            <Skeleton variant="rounded" width="100%" height={48} />
                                        </Grid2>
                                    ))}
                                </Stack>
                            ) : (
                                <>
                                    {employees
                                        .filter((e) => !e.invite_pending)
                                        .map((employee) => (
                                            <Stack
                                                key={String(employee.id)}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    margin: '5px 0',
                                                    borderRadius: '15px',
                                                    border: '1px solid #D9D9D9',
                                                }}
                                            >
                                                <Stack
                                                    sx={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        px: 2,
                                                        py: 0.5,
                                                    }}
                                                >
                                                    <Stack
                                                        sx={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 1.5,
                                                        }}
                                                    >
                                                        <Avatar
                                                            src={employeeListAvatarSrc(employee?.image)}
                                                            alt={employee?.name || ''}
                                                            sx={{ width: 40, height: 40, flexShrink: 0 }}
                                                        >
                                                            {employee?.name?.charAt(0)?.toUpperCase() || ''}
                                                        </Avatar>
                                                        <Typography
                                                            style={{
                                                                minWidth: 0,
                                                                flex: 1,
                                                                size: '20px',
                                                                color: '#A0A0A0',
                                                            }}
                                                        >
                                                            {employee?.name}{' '}
                                                            {employee?.role === 'DOCTOR' && `(${employee?.role})`}
                                                        </Typography>
                                                    </Stack>

                                                    {(user.role === 'ADMIN' || user?.settings.create_employee) && (
                                                        <Stack
                                                            flex={1}
                                                            flexDirection={'row'}
                                                            justifyContent={'flex-end'}
                                                            alignItems={'center'}
                                                        >
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEditEmployee(employee);
                                                                    setShowModal(true);
                                                                }}
                                                                sx={{
                                                                    background: '#ffff',
                                                                    border: 'none',
                                                                    height: 28,
                                                                    width: 28,
                                                                    borderRadius: '50%',
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <img
                                                                    src={PencnlIconImg}
                                                                    alt="Edit"
                                                                    height={22}
                                                                    width={22}
                                                                />
                                                            </IconButton>

                                                            {user?.id !== employee?.id && employee?.role != 'ADMIN' && (
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setEditEmployee(employee);
                                                                        setShowDeleteModal(true);
                                                                    }}
                                                                    sx={{
                                                                        background: '#ffff',
                                                                        border: 'none',
                                                                        marginLeft: 1,
                                                                        borderRadius: '50%',
                                                                        padding: 0,
                                                                    }}
                                                                >
                                                                    <img src={DeleteIconImg} alt="Delete" width={18} />
                                                                </IconButton>
                                                            )}
                                                        </Stack>
                                                    )}
                                                </Stack>
                                            </Stack>
                                        ))}

                                    {(user?.settings.create_employee || user.role === 'ADMIN') && (
                                        <Stack
                                            flex={1}
                                            onClick={() => {
                                                setEditEmployee(null);
                                                setShowModal(true);
                                            }}
                                            flexDirection={'row'}
                                            py={1}
                                            sx={{
                                                width: '100%',
                                                px: 2,
                                                borderRadius: '15px',
                                                border: '1px solid #D9D9D9',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                maxHeight: 40,
                                                mt: loading ? 2 : 0,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    size: '20px',
                                                    color: '#A0A0A0',
                                                    mr: 'auto',
                                                }}
                                            >
                                                {t('Setting.NewEmployee')}
                                            </Typography>
                                        </Stack>
                                    )}

                                    {employees.some((e) => e.invite_pending) ? (
                                        <Stack spacing={1} sx={{ mt: 3, width: '100%' }}>
                                            <FPrimaryHeading
                                                text={t('Setting.InvitedEmployeesSectionTitle')}
                                                fontSize={16}
                                            />
                                            <SecondaryHeading text={t('Setting.InvitedEmployeesSectionDescription')} />
                                            {employees
                                                .filter((e) => e.invite_pending)
                                                .map((employee) => (
                                                    <Stack
                                                        key={String(employee.id)}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            width: '100%',
                                                            margin: '5px 0',
                                                            borderRadius: '15px',
                                                            border: '1px solid #D9D9D9',
                                                        }}
                                                    >
                                                        <Stack
                                                            sx={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                px: 2,
                                                                py: 0.5,
                                                            }}
                                                        >
                                                            <Stack
                                                                sx={{
                                                                    width: '100%',
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    gap: 1.5,
                                                                }}
                                                            >
                                                                <Avatar
                                                                    src={employeeListAvatarSrc(employee?.image)}
                                                                    alt={employee?.name || ''}
                                                                    sx={{ width: 40, height: 40, flexShrink: 0 }}
                                                                >
                                                                    {employee?.name?.charAt(0)?.toUpperCase() || ''}
                                                                </Avatar>
                                                                <Typography
                                                                    style={{
                                                                        minWidth: 0,
                                                                        flex: 1,
                                                                        size: '20px',
                                                                        color: '#A0A0A0',
                                                                    }}
                                                                >
                                                                    {employee?.name}{' '}
                                                                    {employee?.role === 'DOCTOR' &&
                                                                        `(${employee?.role})`}
                                                                </Typography>
                                                            </Stack>

                                                            {(user.role === 'ADMIN' ||
                                                                user?.settings.create_employee) && (
                                                                <Stack
                                                                    flex={1}
                                                                    flexDirection={'row'}
                                                                    justifyContent={'flex-end'}
                                                                    alignItems={'center'}
                                                                    gap={1}
                                                                >
                                                                    <Tooltip title={t('Calendar.Resend')}>
                                                                        <IconButton
                                                                            onClick={() => handleResendInvite(employee)}
                                                                            disabled={
                                                                                resendingInviteId ===
                                                                                getEmployeeInvitationId(employee)
                                                                            }
                                                                            sx={{
                                                                                background: '#ffff',
                                                                                border: 'none',
                                                                                height: 'auto',
                                                                                width: 'auto',
                                                                                borderRadius: '8px',
                                                                                px: 1,
                                                                            }}
                                                                        >
                                                                            {resendingInviteId ===
                                                                            getEmployeeInvitationId(employee) ? (
                                                                                <CircularProgress size={18} />
                                                                            ) : (
                                                                                <MailOutline />
                                                                            )}
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            setEditEmployee(employee);
                                                                            setShowModal(true);
                                                                        }}
                                                                        sx={{
                                                                            background: '#ffff',
                                                                            border: 'none',
                                                                            height: 28,
                                                                            width: 28,
                                                                            borderRadius: '50%',
                                                                            padding: 0,
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={PencnlIconImg}
                                                                            alt="Edit"
                                                                            height={22}
                                                                            width={22}
                                                                        />
                                                                    </IconButton>
                                                                </Stack>
                                                            )}
                                                        </Stack>
                                                    </Stack>
                                                ))}
                                        </Stack>
                                    ) : null}
                                </>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Permissions */}
                    {user?.role === 'ADMIN' && (
                        <React.Fragment>
                            <Divider sx={{ ...dividerSx }} />

                            <Grid2 container spacing={3} sx={{ py: 2, px: { xs: 2, md: 5 } }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <PrimaryHeading text={t('Setting.Permissions')} />
                                    <SecondaryHeading text={t('Setting.Description12')} />
                                </Grid2>

                                <Grid2 container spacing={3} size={{ xs: 12, md: 8 }}>
                                    {/* Employee Select */}
                                    <Grid2 size={12}>
                                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#1F1F1F' }}>
                                            {t('Common.SelectEmployee')}
                                        </Typography>
                                        <FSelect
                                            value={formik?.values?.id || 0}
                                            onChange={handleChangeSelectedEmployee}
                                            options={employees.filter((e) => !e.invite_pending)}
                                            sx={{
                                                width: { xs: '100%', md: '30%' },
                                                mt: 1,
                                                '& .MuiTypography-root': {
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                },
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#1F1F1F' }}>
                                            {t('Setting.RolePreset')}
                                        </Typography>
                                        <FSelect
                                            value={selectedPermissionTemplate}
                                            onChange={(event) => applyPermissionTemplate(event.target.value)}
                                            options={permissionTemplateOptions}
                                            sx={{ width: { xs: '100%', md: '30%' }, mt: 1 }}
                                        />
                                        <Typography variant="body2" sx={{ mt: 1, color: '#666' }}>
                                            {t('Setting.RolePresetHelper')}
                                        </Typography>
                                    </Grid2>

                                    {/* All Permissions toggle */}
                                    <Grid2 size={12}>
                                        <Box sx={{ p: 2, border: '1px solid #EFEFEF', borderRadius: '12px' }}>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700, color: '#1F1F1F', mb: 1.5 }}
                                            >
                                                {t('Setting.AllPermissions')}
                                            </Typography>
                                            <FSwitch
                                                id="allPermission"
                                                checked={formik.values.allPermission}
                                                onChange={(_, value) => setAllPermission(value)}
                                                label={t('Setting.GrantAllPermissions')}
                                            />
                                        </Box>
                                    </Grid2>

                                    {/* ✅ Masonry layout — no more index % 2 splitting */}
                                    <Grid2 size={12}>
                                        <Masonry columns={{ xs: 1, md: 2 }} spacing={2}>
                                            {Object.entries(employeePermissionMapper).map(([key, value]) => (
                                                <Box
                                                    key={key}
                                                    sx={{ p: 2, border: '1px solid #EFEFEF', borderRadius: '12px' }}
                                                >
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: '#1F1F1F',
                                                            mb: 1.5,
                                                            textTransform: 'capitalize',
                                                        }}
                                                    >
                                                        {value.label}
                                                    </Typography>
                                                    {value.permissions?.map((permission) => (
                                                        <Box key={permission.id} sx={{ mb: 1 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <FSwitch
                                                                    id={permission.id}
                                                                    checked={formik.values.permission[permission.id]}
                                                                    disabled={
                                                                        permission.id === BLUR_PRICE_PERMISSION_ID &&
                                                                        !isFromDashboard
                                                                    }
                                                                    onChange={(_, checked) =>
                                                                        onChangeValue(permission, checked)
                                                                    }
                                                                    label={permission.label}
                                                                />

                                                                {permission.extraNote &&
                                                                    permission.id !== BLUR_PRICE_PERMISSION_ID && (
                                                                        <Tooltip title={permission.extraNote}>
                                                                            <InfoOutlined
                                                                                sx={{ fontSize: 16, color: 'gray' }}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                            </Box>
                                                            {permission.id === BLUR_PRICE_PERMISSION_ID &&
                                                                !isFromDashboard && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            display: 'block',
                                                                            color: '#666',
                                                                            mt: 0.5,
                                                                        }}
                                                                    >
                                                                        {t('Setting.BlurPriceContactSupportNote')}
                                                                    </Typography>
                                                                )}
                                                        </Box>
                                                    ))}
                                                    {key === 'POS' && formik.values.permission['view_pos'] === true && (
                                                        <Link to="/pos/settings">
                                                            {t('Setting.DetailedPermissions')}
                                                        </Link>
                                                    )}
                                                </Box>
                                            ))}
                                        </Masonry>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </React.Fragment>
                    )}

                    {isInspectionEnabled && (
                        <React.Fragment>
                            <Divider sx={{ ...dividerSx }} />

                            <Grid2 container sx={{ p: { xs: 2, md: 5 } }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <PrimaryHeading text={t('Setting.AutoSmsEmployeeBeforeHours')} />
                                    <SecondaryHeading text={t('Setting.AutoSmsEmployeeBeforeHoursDescription')} />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 8 }} sx={{ px: 2 }}>
                                    <FPrimaryHeading text={t('Setting.AutoSmsEmployeeBeforeHours')} fontSize={16} />
                                    <FSelect
                                        id={'auto_sms_employee_before_hours'}
                                        value={formik.values?.auto_sms_employee_before_hours || 'NO_SMS'}
                                        onChange={(e) =>
                                            formik.setFieldValue('auto_sms_employee_before_hours', e.target.value)
                                        }
                                        options={[
                                            {
                                                value: 'NO_SMS',
                                                label: t('Setting.NoSms'),
                                            },
                                            { value: 360, label: `6 ${t('Statistics.Hours')}` },
                                            { value: 720, label: `12 ${t('Statistics.Hours')}` },
                                            { value: 1440, label: `24 ${t('Statistics.Hours')}` },
                                            { value: 2880, label: `48 ${t('Statistics.Hours')}` },
                                        ]}
                                        sx={{ width: { xs: '100%', md: '30%' }, mt: 1 }}
                                        showPlaceHolder={false}
                                    />
                                </Grid2>
                            </Grid2>
                        </React.Fragment>
                    )}

                    {/* Service assignment */}

                    <React.Fragment>
                        <Divider sx={{ ...dividerSx }} />

                        <Grid2 container sx={{ p: { xs: 1, md: 5 } }}>
                            <Grid2 size={{ xs: 12, md: 4 }}>
                                <PrimaryHeading text={t('Setting.ServiceAssign')} />
                                <SecondaryHeading text={t('Setting.ServiceAssignDescription')} />
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 8 }} sx={{ px: { xs: 0, sm: 2 } }}>
                                <Stack mt={{ xs: 2, sm: 0 }}>
                                    <FPrimaryHeading text={t('Common.SelectEmployee')} fontSize={16} />
                                    <FSelect
                                        id={'serviceAssign.employee_id'}
                                        value={assignSelectedEmployee}
                                        onChange={(e) => {
                                            const findEmp = empOptions?.find((emp) => emp?.value === e?.target?.value);
                                            setAssignSelectedEmployee(findEmp?.value);
                                        }}
                                        options={empOptions}
                                        sx={{ width: { xs: '100%', md: '30%' }, mt: 1 }}
                                    />
                                </Stack>

                                {assignSelectedEmployee && (
                                    <Stack marginTop={2}>
                                        {serviceGroups?.length === 0 && (
                                            <>
                                                <Skeleton animation="wave" height={60} />
                                                <Skeleton animation="wave" height={60} />
                                                <Skeleton animation="wave" height={60} />
                                                <Skeleton animation="wave" height={60} />
                                                <Skeleton animation="wave" height={60} />
                                            </>
                                        )}
                                        {serviceGroups.map((group, index) => {
                                            const isUngrouped = group?.group === 'Ungrouped services';
                                            const hasServices = group?.services && group.services.length > 0;

                                            if (!isUngrouped && !hasServices) {
                                                return null;
                                            }

                                            return (
                                                <Stack key={group?.id} mb={2}>
                                                    <Stack
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: { xs: 'column', sm: 'row' },
                                                            alignItems: 'center',
                                                            gap: 2,
                                                            mb: { xs: index === 0 ? 2 : 0, sm: 1 },
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 700,
                                                                mb: 1,
                                                                width: { xs: '100%', sm: '33.33%' },
                                                            }}
                                                        >
                                                            {isUngrouped
                                                                ? t('Setting.UngroupedServices')
                                                                : group?.group}
                                                        </Typography>

                                                        {index === 0 && hasServices && (
                                                            <React.Fragment>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        mb: 1,
                                                                        width: { xs: '100%', sm: '50%' },
                                                                        display: { xs: 'none', sm: 'flex' },
                                                                        ml: 1,
                                                                    }}
                                                                >
                                                                    {t('Setting.ServicePrice')}
                                                                </Typography>

                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        mb: 1,
                                                                        display: { xs: 'none', sm: 'flex' },
                                                                        width: { xs: '100%', sm: '15%' },
                                                                        alignItems: 'flex-end',
                                                                        justifyContent: 'flex-end',
                                                                        gap: 6,
                                                                        px: 4,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >
                                                                    <span>{t('Setting.EmployeePrice')}</span>
                                                                    <Tooltip title={t('Setting.AssignTooltip')} arrow>
                                                                        {t('Setting.Assign')}
                                                                    </Tooltip>
                                                                </Typography>
                                                            </React.Fragment>
                                                        )}
                                                    </Stack>

                                                    {hasServices &&
                                                        group.services.map((service) => {
                                                            const index = servicesSelected.findIndex(
                                                                (ser) => ser?.serviceId === service?.id,
                                                            );

                                                            const selected = index !== -1;

                                                            return (
                                                                <Stack
                                                                    key={service?.id}
                                                                    sx={{
                                                                        border: '1px solid #d9d9d9',
                                                                        borderRadius: '12px',
                                                                        flexDirection: { xs: 'column', sm: 'row' },
                                                                        gap: { xs: 0, sm: 2 },
                                                                        mb: { xs: 2, sm: 1 },
                                                                        px: 2,
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    {/* Top row */}
                                                                    <Stack
                                                                        direction="row"
                                                                        sx={{
                                                                            width: '100%',
                                                                            justifyContent: {
                                                                                xs: 'space-between',
                                                                                sm: 'flex-between',
                                                                            },
                                                                            mt: { xs: 1, sm: 0 },
                                                                            gap: { sm: 2 },
                                                                            alignItems: 'flex-start',
                                                                        }}
                                                                    >
                                                                        <Stack
                                                                            sx={{
                                                                                width: { xs: '70%', sm: '50%' },
                                                                                color: '#1a1a1a',
                                                                                fontSize: 16,
                                                                                fontWeight: 500,
                                                                                overflow: 'hidden',
                                                                                display: '-webkit-box',
                                                                                WebkitBoxOrient: 'vertical',
                                                                                WebkitLineClamp: 2, // 👈 2 lines
                                                                                textOverflow: 'ellipsis',
                                                                                wordBreak: 'break-all', // 👈 important for long words
                                                                            }}
                                                                        >
                                                                            {service?.name}
                                                                        </Stack>

                                                                        <Stack
                                                                            sx={{
                                                                                width: { xs: '25%', sm: '15%' },
                                                                                textAlign: 'right',
                                                                                flexShrink: 0,
                                                                                marginRight: { xs: 0, sm: 5 },
                                                                                color: '#666666',
                                                                                fontSize: 14,
                                                                                fontWeight: 500,
                                                                            }}
                                                                        >
                                                                            {formatCurrency(service?.price)}
                                                                        </Stack>
                                                                    </Stack>

                                                                    <FPrimaryHeading
                                                                        text={t('Setting.EmployeePrice')}
                                                                        sx={{
                                                                            fontSize: 14,
                                                                            display: { xs: 'block', sm: 'none' },
                                                                            fontWeight: 600,
                                                                            textAlign: 'left',
                                                                            width: '100%',
                                                                            mt: 2,
                                                                        }}
                                                                    />

                                                                    <Stack
                                                                        direction="row"
                                                                        alignItems="center"
                                                                        gap={2}
                                                                        sx={{
                                                                            width: '100%',
                                                                            justifyContent: {
                                                                                xs: 'space-between',
                                                                                sm: 'flex-end',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <FTextInput
                                                                            value={
                                                                                selected
                                                                                    ? Number(
                                                                                          servicesSelected[index]
                                                                                              ?.employeePrice,
                                                                                      ) || 0
                                                                                    : service?.price
                                                                            }
                                                                            onChange={(e) => {
                                                                                const raw = e.target.value.replace(
                                                                                    /[^\d.]/g,
                                                                                    '',
                                                                                );
                                                                                const value =
                                                                                    raw === '' ? 0 : Number(raw);

                                                                                if (index === -1) return;

                                                                                update(index, {
                                                                                    ...servicesSelected[index],
                                                                                    employeePrice: value,
                                                                                });
                                                                            }}
                                                                            disabled={!selected}
                                                                            width={{ xs: '100px', sm: 150 }}
                                                                            sx={{
                                                                                marginTop: { xs: 0, sm: '6px' },
                                                                                marginBottom: '6px',
                                                                            }}
                                                                            slotProps={{
                                                                                input: {
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            <Typography variant="body2">
                                                                                                {t('POS.Currency')}
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                },
                                                                            }}
                                                                        />
                                                                        <FSwitch
                                                                            checked={selected}
                                                                            onChange={(e, checked) =>
                                                                                handleToggleService(service, checked)
                                                                            }
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            );
                                                        })}
                                                </Stack>
                                            );
                                        })}
                                    </Stack>
                                )}
                            </Grid2>
                        </Grid2>
                    </React.Fragment>

                    {showModal && (
                        <EmployeeModel
                            open={showModal}
                            data={editEmployee}
                            handleRemove={() => {
                                setShowModal(false);
                                setShowDeleteModal(true);
                            }}
                            onClose={() => setShowModal(!showModal)}
                            onSuccess={async () => {
                                await getEmployees();
                                setEditEmployee(null);
                            }}
                        />
                    )}

                    {showDeleteModal && (
                        <CustomDeleteModal
                            open={showDeleteModal}
                            handleClose={handleCloseDeleteModal}
                            description={
                                <>
                                    {t('Setting.AreYouSureYouWantToDelete')}
                                    <span
                                        style={{
                                            marginLeft: 5,
                                            color: '#1F1F1F',
                                            fontWeight: 'bold',
                                            marginRight: 5,
                                        }}
                                    >
                                        {editEmployee?.name}
                                    </span>
                                    {/* {itemsToDelete?.type == 'container' ? 'service group': 'service'} */}
                                </>
                            }
                            onClickDismiss={handleCloseDeleteModal}
                            onClickConfirm={() => deleteEmployee(editEmployee)}
                        />
                    )}
                </Stack>
            </Stack>
        </form>
    );
};

export default EmployeeSettingsOption;
